module.exports = __webpack_public_path__ + "static/Canela-Medium-738a61869d7db8521523504de461fd8a.otf";